import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=9b7c7774"
import script from "./invoice-detail.ts?vue&type=script&lang=js&external"
export * from "./invoice-detail.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports